export default "__VITE_ASSET__D5WPiWi6__"